<!-- https://moservicedesk.atlassian.net/browse/SBE-17 -->
<template>
    <modal
    variant="default"
    no-footer
    @input="handleOpenModal"
    @close="handleCloseModal"
    class="modify-modal modify-modal__discard-edits"
  >
    <template v-slot:default="{ activate }">
      <slot v-bind="{ activate }" />
    </template>
    <template v-slot:body>
      <p class="text">{{ text }}</p>
      <button class="button--primary black size-md"
        @click="dismiss"
        @keydown.space.prevent="dismiss">
        {{ buttonLabel }}
      </button>
    </template>
  </modal>
</template>

<script>
  export default {
    name: 'modify-edit-discard-modal',
    inject: [
     'modifyDetailPage'
    ],
    props: {
      text: {
        type: String,
        required: false
      },
      buttonLabel: {
        type: String,
        required: true,
        default: 'Discard Edits'
      },
    },
    methods: {
      deactivate() {
        this.$emit('deactivate');
      },
      handleCloseModal() {
        document.body.classList.remove('no-scroll');
        this.deactivate()
      },
      handleOpenModal() {
        document.body.classList.add('no-scroll');
      },
      dismiss() {
         window.location.href= this.modifyDetailPage
      }
    }
  }
</script>
